<script>
  import { onMount, createEventDispatcher } from "svelte";
  import { User } from "../../store.js";
  const dispatch = createEventDispatcher();
  import Field from "../FormField.svelte";
  import TextBox from "../HTMLElements/Textbox.svelte";
  import Password from "../HTMLElements/PasswordSetter.svelte";
  import ModalMessage from "../HTMLElements/ModalMessage.svelte";
  import Modal from "../HTMLElements/Modal.svelte";
  import * as Validator from "../Utils/ValidateFormFields.js";
  import wrappedFetch from "../../wrappedFetch.js";

  let success = true;
  let info = "";
  let passwordObj = {};
  passwordObj.current = { value: "", isValid: true, isDirty: false };
  passwordObj.input = { value: "", isValid: false, isDirty: false, ref: null };
  passwordObj.confirmInput = { value: "", isValid: false, isDirty: false, ref: null};

  let isLoading = false;
  let showSuccessMessage = false;
  let ref;
  let isCapsOn = false;
  let doPasswordsMatch = false;
  let showPassword = false;
  let getResetpasswordAttributes;
  let min = 6, max = 24;
  let initialText = "<ul style='list-style-position: outside; padding-left:20px;margin:0px;'>" +
    "<li> The password must be between " +
    min +
    " and " +
    max +
    " characters long.</li>" +
    "<li> Allowed characters: " +
    "<li style='margin-left: 20px; list-style: circle;'> all letters and numbers,</li>" +
    "<li style='margin-left: 20px; list-style: circle;'> !$^&();:-=_+[]{}/#. </li>" +
    "</li>" +
    "<li> Password must not start with a special character.</li>" +
    "</ul>";
  let showForm = false;
  let showCannotChangePasswordError = false;
  $:{showCannotChangePasswordError = getResetpasswordAttributes && getResetpasswordAttributes.usoPasswordChangeMessage != ""}

  onMount(async function() {
 
    await wrappedFetch(`user/CanResetPassword?username=${$User.username}`, {
      method: "post", 
  }) .then(res => res.json())
     .then(result => {                      
       getResetpasswordAttributes = result;
      showForm = true;    
            });

  if(ref)
   ref.focus();
  });

 const selectTextOnFocus = node => { 
   node.focus();
  }

  const createNewPassword = async e => {
    e.preventDefault();
    isLoading = true;
    success = true;


    if (!Validator.validate(passwordObj)) {
      info = "Entered data is invalid.";
      success = false;
      isLoading = false;
      passwordObj = passwordObj;
      return;
    }

    var obj = {};
    obj.username = $User.username;
    obj.currentPassword = passwordObj.current.value;
    obj.password = passwordObj.input.value;
    obj.confirmPass = passwordObj.confirmInput.value;

    const resp = await wrappedFetch("user/changepassword", {
      method: "post",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json"
      }
    });

    var changeResult = await resp.json();
    success = changeResult.success;
    info = changeResult.message;

    isLoading = false;
    $User.shouldForcePasswordChange = false;
    if (success) {
      showSuccessMessage = true;
    }
  };

  const checkCaps = e => {
    if (e.detail.code == "CapsLock") isCapsOn = true;
    else isCapsOn = false;
  };

  const matchPassword = async () => {
    var obj = {};
    obj.username = $User.username;
    obj.password = passwordObj.current.value;

    const resp = await wrappedFetch("user/matchpassword", {
      method: "post",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json"
      }
    });

    doPasswordsMatch = await resp.json();

    if (!doPasswordsMatch) {
      passwordObj.current.isValid = false;
      success = false;
      info = "Current password is incorrect.";
    } else {
      passwordObj.current.isValid = true;
      success = true;
    }
    isLoading = false;
  };
</script>



{#if showForm}
<form action="">
  <div class="field">
               <a href="/user/home">
                 <span class="fas fa-arrow-left" />
                 Back
               </a>
             </div>
             <h1 class="title is-3">Change your Password</h1>
{#if getResetpasswordAttributes &&(getResetpasswordAttributes.usoPasswordChangeMessage != "" || getResetpasswordAttributes.hasOTP)}
<div class="notification is-invalid">
  {#if getResetpasswordAttributes.usoPasswordChangeMessage != ""}
  <p style="margin-bottom:0px;">{@html getResetpasswordAttributes.usoPasswordChangeMessage}</p>
  {:else}
  <p style="margin-bottom:0px;">Please <a href="https://support.lgfl.org.uk/public/changepass.aspx" target="_blank">click here</a> to change your password!</p>
  {/if}
</div>
{:else} 
   <nav class="panel" tabindex="0" aria-label="set password panel">   
     <div class="panel-block">
       <div style="margin: 7.5%; flex:auto;">
         {#if isCapsOn}
           <p class="help has-text-centered">
             <span class="fas fa fa-exclamation-triangle has-text-warning" />
             CAPS is on!
           </p>
         {/if}
         <div class="box" style="background-color: whitesmoke;">
           {@html initialText}
      </div>

         <Field label="Current Password">
           <span slot="inputField">
             <TextBox
               placeholder="Enter current password"
               isRequired="true"
               bind:text={passwordObj.current.value}
               bind:isValid={passwordObj.current.isValid}
               bind:isDirty={passwordObj.current.isDirty}
               bind:ref              
               on:keyup={checkCaps}
               on:blur={matchPassword}
               isPassword="true"
               label="password" />
           </span>
         </Field>
 
         <Password
           bind:password={passwordObj.input}
           bind:confirmPassword={passwordObj.confirmInput}
           showPolicy="false"
           isRequired="true"
           focus={false}
           showCapsWarning={false} />
 
         {#if !success}
           <hr />
           <div class="notification is-invalid">
             <p class="help">{info}</p>
           </div>
         {/if}
 
       </div>
     </div>
   </nav>
 
   <!-- <nav class="panel"> -->
     <div style="text-align: right;margin-top: 15px;">
       <button type="submit" class="button is-purple {isLoading ? 'is-loading' : ''}" on:click={createNewPassword} disabled={isLoading}>
         Save
       </button>
     </div>
   <!-- </nav> -->
 
{/if}
</form>
{/if}
<ModalMessage
  bind:showModal={showSuccessMessage}
  on:continue={() => {
    showSuccessMessage = false;
    dispatch('pageChange', '/user/home');
  }}>
  <p>Your password has been changed successfully!</p>
</ModalMessage>
<!-- <Modal bind:showModal={showCannotChangePasswordError} allowClose={false}>
  <p>{checkCanChangePasswordInUso}</p>
</Modal> -->
